module.exports = __webpack_public_path__ + "files/5de61aa9cb023b3193953129878566cd.png";